import { b2cPagesService } from '@clubmed/utils';
import { getFromLocalStorage, setInLocalStorage } from 'Client/local-storage-api';
import {
  SHOPPING_TRACKING,
  SHOPPING_LAST_VISITED_PRODUCTS,
  SHOPPING_LAST_VISITED_PRODUCTS_NUMBER,
} from 'Tracking/constants';
const {
  PAGE_TYPES: { RESORT, TOUR, CRUISE, RESORT_MICE },
} = b2cPagesService;
type VisitedProduct = {
  id: string;
  be: boolean;
  timestamp: number;
};
type ShoppingTracking = Record<
  typeof SHOPPING_LAST_VISITED_PRODUCTS,
  Array<VisitedProduct | string>
>;
export function getLastVisitedProducts(): Array<VisitedProduct> {
  const trackingShopping = getFromLocalStorage<ShoppingTracking>(SHOPPING_TRACKING);
  const lastVisitedProducts = trackingShopping?.[SHOPPING_LAST_VISITED_PRODUCTS] || [];
  // it handles old data: string[]
  // to delete when it's safe
  return lastVisitedProducts.map((visitedProduct, index: number) => {
    if (typeof visitedProduct === 'string') {
      return {
        id: visitedProduct,
        be: false,
        timestamp: Date.now() + index,
      };
    }

    return visitedProduct;
  });
}
export function getLastVisitedProductIds(): Array<string> {
  return getLastVisitedProducts().map(({ id }) => id);
}
export function trackLastVisitedProducts(pageType: string, product: VisitedProduct) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageType) && product?.id) {
    let lastVisitedProducts = getLastVisitedProducts();
    const targetProduct = lastVisitedProducts.find(
      (visitedProduct: VisitedProduct) => visitedProduct.id === product.id,
    );

    if (targetProduct) {
      // once it's true (BE) it can't go back to false
      targetProduct.be = product.be || targetProduct.be;
    } else {
      lastVisitedProducts = [product, ...lastVisitedProducts];
    }

    lastVisitedProducts = lastVisitedProducts
      .sort((a, b) => Number(b.be) - Number(a.be) || b.timestamp - a.timestamp)
      .slice(0, SHOPPING_LAST_VISITED_PRODUCTS_NUMBER);
    setInLocalStorage<ShoppingTracking>(SHOPPING_TRACKING, {
      [SHOPPING_LAST_VISITED_PRODUCTS]: lastVisitedProducts,
    });
  }
}
